export const TwitchLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="white"
    {...props}
  >
    <title>Twitch Logo</title>
    <path d="M3.125 1.25L1.875 4.375V16.25H5.625V18.75H8.125L10.625 16.25H13.75L18.125 11.875V1.25H3.125ZM16.25 11.25L13.75 13.75H10L7.5 16.25V13.75H4.375V3.125H16.25V11.25Z" />
    <path d="M14.375 5.58594H12.5V10.625H14.375V5.58594Z" />
    <path d="M10 5.58594H8.125V10.625H10V5.58594Z" />
  </svg>
);
